import { DeviceConfigSyncClient, type DeviceConfigSyncResult } from "./device-config-sync";
import { SyncClient, type SyncResult } from "./sync-client";

export type DualStreamSyncResult = SyncResult & DeviceConfigSyncResult;

export class DualStreamSyncClient {
  constructor(private readonly orders: SyncClient, private readonly config: DeviceConfigSyncClient) {}

  async sync(): Promise<DualStreamSyncResult> {
    const orderResult = await this.orders.sync();
    try {
      const configResult = await this.config.refresh();
      return { ...orderResult, ...configResult };
    } catch (error) {
      return {
        ...orderResult,
        changed: false,
        revision: null,
        configError: error instanceof Error ? error.message : "Device Config refresh failed",
      };
    }
  }
}
